import { useTranslation } from "react-i18next";
import { useTheme } from "../theme/useTheme";
import { IconInfo, IconExpandLess, IconExpandMore } from 'cdk-radial';
import { UserCardsContainer, UserCardsHeader } from "./UserCardStyles"
import { useEffect, useState } from "react";
import UserCardLayout from './UserCardLayout';
import { UserCardsList } from "./UserCardsList";
import { RoundedIconButton } from "../../components/Buttons/IconButton";
import { useFeatureFlag } from '@harnessio/ff-react-client-sdk';
import { useGetAllNotifications, useGetDepartments } from "../dealer-admin/custom-user-links/useLinkQueries";
import useProfileStore from "../core/UserProfileStore";
import { useShowDialog } from '../../contexts/AppStateContext';
import { getActiveLinks } from "../utils/getActiveLinks";

export interface CustomApps {
    apps: UserCard[];
    loginId?: string;
    enterpriseId?: string;
}

export interface UserCard {
    name?: string;
    description?: string;
    url?: string;
    iconText?: string;
    appId?: string;
    loginId?: string;
    enterpriseId?: string;
    startDate?: string;
    endDate?: string;
    target?: {
        department?: string[];
    };
}

export interface CardMenu {
    label: string;
    key: string;
    icon: JSX.Element;
}

export function UserCards() {
    const { t } = useTranslation();
    const { unifyUserProfile } = useProfileStore();
    const departmentTypes = unifyUserProfile?.departmentTypes;
    const menuOptions: CardMenu[] = [
        { label: t('baseCard.menu.learnMore'), key: 'LEARN_MORE', icon: <IconInfo /> },
    ];

    const userCustomCardsFeature = useFeatureFlag('UNIFY_UI_CUSTOM_CARDS');
    const { darkMode } = useTheme();
    const [userCardList, setUserCardList] = useState<CustomApps>();
    const [isExpanded, setIsExpanded] = useState(true);
    const showDialog = useShowDialog();
    const { enterpriseId } = unifyUserProfile;

    // Fetch links (not archived)
    const { data: userCards } = useGetAllNotifications<CustomApps>(false, enterpriseId);
    const { data: departmentList } = useGetDepartments();

    useEffect(() => {
        if (userCards) {
            setUserCardList(userCards);
        }
            }, [userCards]);

    const menuHandler = (option: CardMenu, { iconText, description, name, url, appId }: UserCard) => {
        switch (option.key) {
            case 'LEARN_MORE':
                showDialog('LEARN_MORE', {
                    iconColor: "#000",
                    iconText,
                    name,
                    description,
                    isEnabled: true,
                    showDescription: true,
                });
                break;
        }
    };

    const acitveLinks = getActiveLinks(userCardList, departmentTypes, departmentList);

    return (
        <>
            {userCustomCardsFeature && userCardList && acitveLinks?.length > 0 ?
                <UserCardsContainer>
                    <UserCardLayout isExpanded={isExpanded} darkMode={darkMode} closedHeight={"36px"}>
                        <UserCardsHeader>
                            <span style={{ paddingRight: "20px" }}>{t('myUnifyTab.myCards')}</span>
                            <RoundedIconButton
                                dataTestId="expand-user-cards"
                                icon={
                                    isExpanded ? (
                                        <IconExpandLess />
                                    ) : (
                                        <IconExpandMore />
                                    )
                                }
                                style={{ marginLeft: 'auto' }}
                                darkMode={darkMode}
                                onClick={() => setIsExpanded(!isExpanded)}
                                text=""
                            />
                        </UserCardsHeader>
                        <UserCardsList
                            userCardList={userCardList}
                            menuOptions={menuOptions}
                            menuHandler={menuHandler}
                        />
                    </UserCardLayout>
                </UserCardsContainer>: null
            }
        </>
    )
}